import { useState } from "react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel } from "@/components/ui/alert-dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import * as Icons from "lucide-react";

// Typed confirmation gate for sensitive saves and destructive actions.
export function ConfirmTyped({ pending, onCancel }) {
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  if (!pending) return null;
  const word = pending.word || "CONFIRM";
  const ok = typed.trim().toUpperCase() === word;
  const go = async () => {
    setBusy(true);
    try { await pending.run(); } finally { setBusy(false); setTyped(""); onCancel(); }
  };
  return (
    <AlertDialog open onOpenChange={(o) => { if (!o) { setTyped(""); onCancel(); } }}>
      <AlertDialogContent data-testid="confirm-typed-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2"><Icons.ShieldAlert className="h-5 w-5 text-red-600" /> {pending.title}</AlertDialogTitle>
          <AlertDialogDescription>{pending.description} Type <b className="font-mono text-foreground">{word}</b> to continue.</AlertDialogDescription>
        </AlertDialogHeader>
        <Input autoFocus value={typed} onChange={(e) => setTyped(e.target.value)} placeholder={word} data-testid="confirm-typed-input" />
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-typed-cancel">Cancel</AlertDialogCancel>
          <Button variant="destructive" disabled={!ok || busy} onClick={go} data-testid="confirm-typed-submit">{busy ? "Working…" : "Confirm"}</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
